module.exports = __webpack_public_path__ + "static/media/selfie_helper_empty.29cc31c1.svg";